module.exports = __webpack_public_path__ + "img/management-feature-2.d84bbe66.svg";